export default __webpack_public_path__ + "static/media/pattern-7.990dcb66.jpg";